import React, { useMemo } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement);

export const SPARKLINE_COLORS = {
  high: "#46DC94",
  medium: "#FFDD67",
  low: "#ED6767",
  flat: "#FF627D",
};

export const resolveSparklineColor = ({ trend = "flat", progressTone = "medium" }) => {
  if (trend === "down") {
    return SPARKLINE_COLORS.low;
  }
  if (progressTone === "high" || trend === "up") {
    return SPARKLINE_COLORS.high;
  }
  if (progressTone === "low") {
    return SPARKLINE_COLORS.low;
  }
  return SPARKLINE_COLORS.medium;
};

const MuscleEvolutionSparkline = ({
  timeline = [],
  trend = "flat",
  progressTone = "medium",
}) => {
  const borderColor = resolveSparklineColor({ trend, progressTone });

  const chartData = useMemo(
    () => ({
      labels: timeline.map((_, index) => index),
      datasets: [
        {
          data: timeline.map((point) => point.value),
          borderColor,
          backgroundColor: borderColor,
          borderWidth: 2,
          pointRadius: 2,
          pointHoverRadius: 3,
          pointBackgroundColor: borderColor,
          pointBorderColor: "#FFFFFF",
          pointBorderWidth: 1,
          tension: 0.35,
          fill: false,
        },
      ],
    }),
    [timeline, borderColor]
  );

  const chartOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
      },
      scales: {
        x: {
          display: false,
          grid: { display: false },
        },
        y: {
          display: false,
          grid: { display: false },
        },
      },
    }),
    []
  );

  if (timeline.length === 0) {
    return <span className="muscle-evolution-sparkline muscle-evolution-sparkline--empty">—</span>;
  }

  return (
    <div className="muscle-evolution-sparkline" aria-hidden="true">
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};

export default MuscleEvolutionSparkline;
